import { withReduxProvider } from './src/components/hoc/withReduxProvider'
import { withAppInit } from './src/components/hoc/withAppInit'
import { withUseQueryProvider } from './src/components/hoc/withUseQueryProvider'

export const wrapRootElement = ({ element }: { element: any }) =>
  withUseQueryProvider(withReduxProvider(withAppInit(element)))
